import { Checkbox, Col, Modal, Row } from 'antd'
import React, { useEffect, useState } from 'react'
import RangePicker from '../RangePicker'
import './style.css'
import { Colors } from '../../config';

// dummy data

const dummyData = [
    {
        title: 'main title',
        id: 3,
        services: [
            {
                title: 'secondLayer subService',
                id: 182,
                services: [{ id: 184, name: 'test 2' }, { id: 183, name: 'test 1' }]
            },
            {
                title: 'secondLayer subService',
                id: 181,
                services: [
                    { id: 186, name: 'New service layer' },
                    { id: 185, name: 'check service' }
                ]
            },
            { title: 'test', id: 45, services: [] }
        ]
    },
    {
        title: 'main title',
        id: 4,
        services: [
            {
                title: 'secondLayer subService',
                id: 182,
                services: [{ id: 184, name: 'test 2' }, { id: 183, name: 'test 1' }]
            },
            {
                title: 'secondLayer subService',
                id: 181,
                services: [
                    { id: 186, name: 'New service layer' },
                    { id: 185, name: 'check service' }
                ]
            },
            { title: 'test', id: 45, services: [] }
        ]
    }
]

const SubServicesFilters = ({ servicesModal, setServicesModal, isRadius = true, advanceFiltersValueHandler, data, selectedData = {}, selectedRadiusValue }) => {

    const servicesData = data || dummyData;


    // setting range value default would be 20
    const [rangeValue, setRangeValue] = useState(20);

    // state is getting created dynamically based on the number of objects i am getting in an array like { serviceId: { subServiceId: [ subSubServiceId ], subServiceId: [ subSubServiceId, subSubServiceId ] } }
    const [selectedServices, setSelectedServices] = useState(() => {
        const initialSelected = {};
        if (servicesData?.length > 0) {
            servicesData.forEach((item) => {
                initialSelected[item.id] = {};  // Each service will have its own sub-services selected state
                item.services.forEach(subService => {
                    initialSelected[item.id][subService.id] = []; // Each sub-service has an array of selected thirdSubServices
                });
            });
        }
        return initialSelected;
    });


    // case to handle the already selected values for a checkbox in case if user came back 
    // from the list view to the card view again so the state for checkbox should remain there.
    useEffect(() => {
        if (selectedData && Object.keys(selectedData)?.length > 0) {
            let tempObject = {};
            // Loop through each service in servicesData
            for (const service of servicesData) {
                if (selectedData[service?.id] && Object.keys(selectedData[service?.id])?.length > 0) {
                    tempObject[service?.id] = {}; // Initialize the service object in tempObject
                    // Loop through each secondSubService (sub-service)
                    for (const secondSubService of service?.services || []) {
                        if (selectedData[service?.id][secondSubService?.id]) {
                            // Add the selected thirdSubService ids for the secondSubService
                            tempObject[service?.id][secondSubService?.id] = selectedData[service?.id][secondSubService?.id];
                        }
                    }
                }
            }
            setSelectedServices(tempObject); // Update the selectedServices state
        }

        if (selectedRadiusValue) {
            setRangeValue(selectedRadiusValue); // Handle radius value separately
        }

    }, [selectedData, selectedRadiusValue, servicesData]);

    // used to handle the individual logic and update the state based on its respective key
    const handleServiceChange = (thirdSubServiceId, serviceId, secondSubServiceId) => {
        setSelectedServices((prevSelected) => {

            const updatedServices = {
                ...prevSelected,
                [serviceId]: {
                    ...prevSelected[serviceId],
                    [secondSubServiceId]: [...(prevSelected[serviceId]?.[secondSubServiceId] || [])]
                }
            };

            // Initialize serviceId if not present
            if (!updatedServices[serviceId]) {
                updatedServices[serviceId] = {};
            }

            // Initialize secondSubServiceId if not present
            if (!updatedServices[serviceId][secondSubServiceId]) {
                updatedServices[serviceId][secondSubServiceId] = [];
            }

            // Check if thirdSubServiceId is already selected
            if (updatedServices[serviceId][secondSubServiceId].includes(thirdSubServiceId)) {
                // Remove the id if already selected (uncheck)
                updatedServices[serviceId][secondSubServiceId] = updatedServices[serviceId][secondSubServiceId].filter(id => id !== thirdSubServiceId);
            } else {
                // Add the id if not selected (check)
                console.log(updatedServices[serviceId][secondSubServiceId])
                console.log(thirdSubServiceId)
                updatedServices[serviceId][secondSubServiceId].push(thirdSubServiceId);
            }

            return updatedServices;
        });
    };


    // used to handle the checkAll logic and update the state based on its respective key
    const handleCheckAll = (serviceId, secondSubServiceId, thirdSubServices, checked) => {
        setSelectedServices((prevSelected) => {
            const updatedServices = { ...prevSelected };

            // Initialize serviceId if not present
            if (!updatedServices[serviceId]) {
                updatedServices[serviceId] = {};
            }

            // Initialize secondSubServiceId if not present
            if (!updatedServices[serviceId][secondSubServiceId]) {
                updatedServices[serviceId][secondSubServiceId] = [];
            }

            if (checked) {
                // Select all thirdSubServices under the specific secondSubService
                updatedServices[serviceId][secondSubServiceId] = thirdSubServices.map(sub => sub.id);
            } else {
                // Deselect all thirdSubServices under the specific secondSubService
                updatedServices[serviceId][secondSubServiceId] = [];
            }

            return updatedServices;
        });
    };



    // function is used to submit the modal and send the data to the parent component
    const onModalSubmitter = () => {
        setServicesModal(false)
        let radiusValue = isRadius ? rangeValue : null
        advanceFiltersValueHandler(selectedServices, radiusValue)
        console.log(selectedServices)
    }

    // function is used to close the modal 
    const onModalCloser = () => {
        setServicesModal(false)
    }

    // handling the picker value and sending it the parent function
    const rangePickerValueHandler = (value) => {
        setRangeValue(value)
    }

    return (
        <Modal
            title=""
            centered
            open={servicesModal}
            width={900}
            onOk={() => onModalSubmitter()}
            onCancel={() => onModalCloser()}
            okText={'Submit'}
            cancelButtonProps={{ style: { display: 'none' } }}
            okButtonProps={{ style: { width: '200px', height: '40px', background: Colors.AppYellow, marginRight: '16px', marginBottom: '10px' } }}
            className='my-4 md:my-0 advanceFilterModal'
            style={{ padding: '20px' }}
        >

            {
                servicesData?.length > 0 ?
                    <Row className='w-full h-[450px] overflow-y-auto px-4 scrollbar-style'>
                        {
                            servicesData?.map((service, index) => {
                                return (
                                    <Row className='w-full mb-4' key={index}>
                                        <Col span={24} className='flex flex-col'>
                                            <p className='text-lg font-semibold'>{service?.title}</p>
                                        </Col>
                                        {
                                            isRadius &&
                                            <Row className='border mt-4 mb-1 px-2 md:px-4 bg-[#f1f6fa] border-none w-full'>
                                                <Col className='flex flex-wrap items-center' span={24}>
                                                    <div className='flex flex-col w-full md:flex-1'>
                                                        <span className='font-semibold'>Radius</span>
                                                        <span className='font-semibold'>Select the search radius for service providers:</span>
                                                    </div>
                                                    <div className='w-full md:flex-1'>
                                                        <RangePicker rangePickerValueHandler={rangePickerValueHandler} rangePickerValue={rangeValue} />
                                                    </div>
                                                </Col>
                                            </Row>
                                        }
                                        <div className='border-2 h-[355px] overflow-y-auto main-container mt-3 w-full'>
                                            <p className='m-2'>Choose your services</p>
                                            <Row className='border-none mt-4 mb-1  flex justify-between gap-2 items-center px-2 w-full'>
                                                {
                                                    service?.services?.length > 0 ?
                                                        service?.services.map((secondSubService, index) => (
                                                            <Col lg={11} xl={11} md={11} sm={24} xs={24} key={index} className=''>
                                                                <div className="w-full mb-1 flex justify-between items-center">
                                                                    <span className="text-md font-semibold">{secondSubService.title}</span>
                                                                    <Checkbox
                                                                        indeterminate={
                                                                            !secondSubService?.services?.length === 0 &&
                                                                            selectedServices[service?.id]?.[secondSubService.id]?.length > 0 &&
                                                                            selectedServices[service?.id]?.[secondSubService.id]?.length < secondSubService?.services?.length
                                                                        }
                                                                        id='myCheckbox'
                                                                        disabled={secondSubService?.services?.length === 0}
                                                                        checked={
                                                                            selectedServices[service?.id]?.[secondSubService.id]?.length === secondSubService?.services?.length
                                                                        }
                                                                        onChange={(e) => handleCheckAll(service?.id, secondSubService.id, secondSubService.services, e.target.checked)}
                                                                    >
                                                                        Check All
                                                                    </Checkbox>

                                                                </div>

                                                                <div className="bg-[#f1f6fa] h-[200px] overflow-y-auto sub-container rounded-md p-2 w-full">
                                                                    <Checkbox.Group value={selectedServices[service?.id]?.[secondSubService.id]} className='w-full'>
                                                                        <Row gutter={[16, 10]} className='w-full'>
                                                                            {
                                                                                secondSubService?.services?.length > 0 ?
                                                                                    secondSubService?.services.map((thirdSubService) => (
                                                                                        <Col lg={12} key={thirdSubService.id} className=''>
                                                                                            <Checkbox
                                                                                                className=''
                                                                                                value={thirdSubService.id}
                                                                                                onChange={() => handleServiceChange(thirdSubService.id, service?.id, secondSubService.id)}>
                                                                                                {thirdSubService.name}
                                                                                            </Checkbox>
                                                                                        </Col>
                                                                                    )) : <p className='ml-2'>No SubService available</p>
                                                                            }
                                                                        </Row>
                                                                    </Checkbox.Group>

                                                                </div>
                                                            </Col>
                                                        ))
                                                        :
                                                        <p className='ml-2'>No SubService available</p>
                                                }
                                            </Row>
                                        </div>
                                    </Row>
                                )
                            })
                        }
                    </Row>

                    :

                    <p className='ml-2'>No Service available</p>
            }

            {/* <span className=''>Choose your services</span>
            {
                isRadius &&
                <Row className='border mt-4 mb-1 px-4 bg-[#f1f6fa] border-none'>
                    <Col className='flex items-center' span={24}>
                        <div className='flex flex-col flex-1'>
                            <span className='font-semibold'>Radius</span>
                            <span className='font-semibold'>Select the search radius for service providers:</span>
                        </div>
                        <div className='flex-1'>
                            <RangePicker rangePickerValueHandler={rangePickerValueHandler} rangePickerValue={rangeValue} />
                        </div>

                    </Col>
                </Row>
            }


            <div className='border-2 h-[355px] overflow-y-auto main-container mt-3'>
                <Row className='border mt-4 mb-1 border-none flex justify-between gap-2 items-center px-2'>
                    {servicesData.map((mainService, index) => (
                        <Col lg={11} xl={11} md={11} sm={24} xs={24} key={index}>
                            <div className="w-full mb-1 flex justify-between items-center">
                                <span className="text-md font-semibold">{mainService.title}</span>
                                <Checkbox
                                    indeterminate={false}
                                    id='myCheckbox'
                                    checked={selectedServices[mainService.title]?.length === mainService?.services?.length}
                                    onChange={(e) => handleCheckAll(mainService.title, mainService.services, e.target.checked)}>
                                    Check All
                                </Checkbox>
                            </div>

                            <div className="bg-[#f1f6fa] h-[200px] overflow-y-auto sub-container rounded-md p-2">
                                <Checkbox.Group
                                    style={{ width: '100%' }}
                                    value={selectedServices[mainService.title]}
                                >
                                    <Row gutter={[16, 10]}>
                                        {mainService.services.map((service) => (
                                            <Col span={12} key={service.id}>
                                                <Checkbox
                                                    value={service.id}
                                                    onChange={() => handleServiceChange(service.id, mainService.title)}>
                                                    {service.name}
                                                </Checkbox>
                                            </Col>
                                        ))}
                                    </Row>
                                </Checkbox.Group>
                            </div>
                        </Col>
                    ))}
                </Row>

            </div> */}
        </Modal>
    )
}

export default SubServicesFilters